// function to sort an object by its value property
function str_limit(str_value, number){
    
    if (typeof number !== 'number') throw 'enter a number type for: '+number;

    if (typeof str_value !== 'string') throw 'enter a string type for: '+str_value;
    
    if (str_value.length <= number) return str_value;
    return str_value.substr(0, number) + ' ...'
}

module.exports = str_limit


// WEBPACK FOOTER //
// ./src/assets/js-on/strlimit.js